document.addEventListener("scroll", function() {
    const stickyNav = document.getElementById("sticky-nav");
    if (window.scrollY > 100) { // Adjust this value to your needs
        stickyNav.classList.add("is--shown");
    } else {
        stickyNav.classList.remove("is--shown");
    }
});
